import {
  Box,
  Heading,
  VStack,
  Card,
  CardBody,
  CardHeader,
} from "@chakra-ui/react"
import defaultGameData from "../../defaultGameData"
import { ReviewSlide } from "./ReviewSlide"
import type { SlideGeneric } from "@types"

export default function ReviewPage() {
  return (
    <Box
      minH="100vh"
      bgGradient="linear(to-br, #7c3aed, #5b4dd6)"
      p={{ base: 4, md: 6, lg: 8 }}
    >
      <Box maxW="1400px" mx="auto">
        <VStack spacing={8} align="stretch">
          <Heading
            as="h1"
            size={{ base: "xl", md: "2xl" }}
            textAlign="center"
            color="white"
            mb={4}
          >
            Slide Content Review
          </Heading>

          {defaultGameData.map(deck => (
            <Box key={deck.title}>
              {/* Deck Title - Just a header, no card */}
              <Heading
                as="h2"
                size="lg"
                color="white"
                mb={6}
                textAlign="center"
              >
                {deck.title}
              </Heading>

              {/* Groups as Cards */}
              <VStack spacing={6} align="stretch">
                {deck.groups?.map(group => (
                  <Card
                    key={group.title}
                    bg="white"
                    borderRadius="2xl"
                    boxShadow="2xl"
                    overflow="hidden"
                  >
                    <CardHeader
                      bg="purple.50"
                      borderBottom="1px"
                      borderColor="purple.100"
                    >
                      <Heading as="h3" size="md" color="purple.700">
                        {group.title}
                      </Heading>
                    </CardHeader>
                    <CardBody p={{ base: 4, md: 6 }}>
                      <VStack spacing={6} align="stretch">
                        {group.slides?.map((slide, index) => (
                          <ReviewSlide
                            key={`${group.title}-${index}`}
                            slide={slide as SlideGeneric}
                            groupName={group.title}
                            deckName={deck.title}
                          />
                        ))}
                      </VStack>
                    </CardBody>
                  </Card>
                ))}
              </VStack>
            </Box>
          ))}
        </VStack>
      </Box>
    </Box>
  )
}
